import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=42561066"
var script = {}


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-2064ba0760/5/root/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports